import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteSolrCollection, getSolrCollections } from '../../../actions';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Icon, Toast } from '@plone/volto/components';
import deleteSVG from '@plone/volto/icons/delete.svg';

// Whether the search shows the collection with this uid
const showsCollection = (location, uid) =>
  location?.pathname === '/search' &&
  new URLSearchParams(location.search).get('uid') === uid;

const SolrCollections = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const items = useSelector((state) => state.solrcollection?.result ?? []);
  // A second click on the same collection must not send the request again
  const deleting = useRef(new Set());

  useEffect(() => {
    dispatch(getSolrCollections());
  }, [dispatch]);

  // The page is not reloaded any more, the navbar waits for the answer and
  // fetches the collections again (#22806)
  const onDelete = (uid) => {
    if (deleting.current.has(uid)) {
      return;
    }
    deleting.current.add(uid);
    dispatch(deleteSolrCollection({ uid }))
      // the service answers true once the collection is deleted; its false
      // arrives as the text 'false', because the Api helper of Volto falls
      // back to the text of a falsy body
      .then(
        (result) => result === true,
        () => false,
      )
      .then((deleted) => {
        deleting.current.delete(uid);
        if (!deleted) {
          toast.error(
            <Toast
              error
              title={'Fehler'}
              content={'Die Kollektion konnte nicht gelöscht werden'}
            />,
          );
        } else if (showsCollection(history.location, uid)) {
          history.push('/search');
        }
        dispatch(getSolrCollections());
      });
  };

  //noinspection JSUnusedLocalSymbols
  return (
    <>
      {items
        ? Array.from(items).map((entry, index) => {
            return (
              <div key={index} className={'solrcollection-entry'}>
                <Link
                  className={'solrcollection-title'}
                  to={'/search?uid=' + entry.uid}
                >
                  {entry.title}
                </Link>
                <Icon
                  className={'solrcollection-delete'}
                  name={deleteSVG}
                  size="18px"
                  onClick={() => onDelete(entry.uid)}
                ></Icon>
              </div>
            );
          })
        : null}
    </>
  );
};

export default SolrCollections;
